import { List } from '@shared/models/interfaces/List.interface';
import { Segment } from '@shared/models/interfaces/segment.interface';

export class SetSegments {
  static readonly type = '[Segment] Set Item';
  constructor(public segments: List<Segment>) {}
}
